import type { OriginJunctionCriteriaPayload } from "../../../hooks/react-query/backOffice/transitTimesAndServiceLevels/useAddOriginJunction";

export const mockOriginJunctionCriteria: OriginJunctionCriteriaPayload = {
  groups: [
    {
      id: "mock-oj-criteria-group-1",
      sequences: [
        {
          id: "mock-oj-criteria-seq-1",
          startTableName: "SHIPMENT",
          endTableName: "ZONE",
          startFieldName: "APPT_REQUIRED",
          endFieldName: "ZONE_CODE",
          startLookup: "COLLECT_BILL",
          endLookup: "ZONE_CODE",
          startLogic: "!=",
          endLogic: ">=",
          logicValue: "not like",
          startMin: "CA, OR, WA",
          startMax: "CA, OR, WA",
          endMin: "CA, OR, WA",
          endMax: "CA, OR, WA",
          reverseRange: true,
        },
      ],
    },
    {
      id: "mock-oj-criteria-group-2",
      sequences: [
        {
          id: "mock-oj-criteria-seq-2",
          startTableName: "SHIPMENT",
          endTableName: "ZONE",
          startFieldName: "APPT_REQUIRED",
          endFieldName: "ZONE_CODE",
          startLookup: "COLLECT_BILL",
          endLookup: "ZONE_CODE",
          startLogic: "!=",
          endLogic: ">=",
          logicValue: "not like",
          startMin: "CA, OR, WA",
          startMax: "CA, OR, WA",
          endMin: "CA, OR, WA",
          endMax: "CA, OR, WA",
          reverseRange: true,
        },
      ],
    },
  ],
  betweenGroupLogic: ["AND"],
};

export const mockEolOriginJunctionsLinehaulApiRows = [
  {
    id: 1,
    sequence: 1,
    junctionCode: "DAL",
    serviceLevels: ["LTL", "LTL-CC", "LTL-UC"],
    additionalDays: 1,
    status: "Active",
    effectiveDate: "01/01/2026",
    expiryDate: "01/01/2027",
    adjIndicator: false,
    finalDeliveryVendor: null,
  },
  {
    id: 2,
    sequence: 2,
    junctionCode: "HOU",
    criteriaId: 91001,
    numberOfGroups: 2,
    numberOfSequences: 2,
    serviceLevels: ["LTL", "LTL-CC"],
    additionalDays: 2,
    status: "Active",
    effectiveDate: "08/19/2024",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    finalDeliveryVendor: null,
  },
  {
    id: 3,
    sequence: 3,
    junctionCode: "ATL",
    serviceLevels: ["LTL", "LTL-CC", "LTL-UC"],
    additionalDays: 0,
    status: "Inactive",
    effectiveDate: "03/15/2024",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    finalDeliveryVendor: null,
  },
];
